import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import Excelformart from './farmer.xlsx';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Badge from '@mui/material/Badge';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Avatar from '@mui/material/Avatar';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getfarmer } from '../redux/farmer';
import * as Xlsx from 'xlsx';




const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:550,
  Height:"100%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


export default function BasicModal() {

  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]


  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [gender, setgender] = React.useState("none");
  const [ownershiptype, setownershiptype] = React.useState("none");
  const [cultivatingmethod, setcultivatingmethod] = React.useState("none");
  const [croptype, setcroptype] = React.useState("none");
  const [seed, setseed] = React.useState("none");
  const [fertilizer, setfertilizer] = React.useState("none");
  const [water, setwater] = React.useState("none");
  const [disability, setdisability] = React.useState("none");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [personName, setPersonName] = React.useState([]);
  const [person, setperson] = React.useState("")
  const dispatch = useDispatch()
  const [filerjson, setfilerjson] = React.useState([]);
  const [filer, setfiler] = React.useState([]);


  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]
 

  var fertilizers=[

    "Insecticides",
    "Herbicides",
    "Fungicides",
    "Rodenticides",
    "Nematicides",
    "Acaricides",
    "Macronutrient Fertilizers",
    "Micronutrient Fertilizers",
    "Organic Fertilizers",
    "Slow-Release Fertilizers",
    "Liquid Fertilizers",
    "Inorganic (Chemical) Fertilizers",
    "Specialty Fertilizers",
    
  ]

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const imagehandler = (e) => {
    const reader = new FileReader()
    reader.onload = () => {
        if (reader.readyState === 2) {
            setperson(reader.result)
        }
    }

    reader.readAsDataURL(e.target.files[0])
}


  // functions

  const addfarmer= () =>{
    setloading(true)
    const file = document.getElementById("fileimage").files[0]
    const image = ""
      
    const fd = new FormData()
                   
                    if (file) {
                   
                        fd.append("file", file)
                        fd.append("image", document.getElementById("fileimage").files[0].name)
                    }

                    fd.append("farmername", document.getElementById("farmername").value)
                    fd.append("contact", document.getElementById("contact").value)
                    fd.append("gender", gender)
                    fd.append("disability", disability)
                    fd.append("dob", document.getElementById("dob").value)
                    fd.append("idnumber", document.getElementById("idnumber").value)
                    fd.append("address", document.getElementById("address").value)
                    fd.append("community", document.getElementById("community").value)
                    fd.append("district", document.getElementById("district").value)
                    fd.append("region", document.getElementById("region").value)
                    fd.append("gpslocation", document.getElementById("gpslocation").value)
                    fd.append("estimatedfarmsize", document.getElementById("estimatedfarmsize").value)
                    fd.append("actualfarmsize", document.getElementById("actualfarmsize").value)
                    fd.append("ownershiptype", ownershiptype)
                    fd.append("croptype", personName)
                    fd.append("cultivatingmethod", cultivatingmethod)
                    fd.append("watter", water)
                    fd.append("acreage", document.getElementById("acreage").value)
                    fd.append("machinery", document.getElementById("machinery").value)
                    fd.append("others", document.getElementById("others").value,              )
    
    
    
    const doer = async () => {
        
        try{

        await axios.post("https://embert.sisrevolution.com/api/farmer/addfarmer/",fd, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log("farmer res")
                    console.log(res)
                    dispatch(getfarmer({

                      data: res.data

                  })) 
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

}

const names = [

  "Maize",
  "Soya Beans",
  "Onion",
  "Pepper",
  "Tomatoes"

];



const readUploadFile = (e) => {
    // e.preventDefault();
    if(e.length!==0 && e.target.files[0].name.split(".")[1]==="xlsx"){
       
    if (e.target) {
       
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            
            const workbook = Xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = Xlsx.utils.sheet_to_json(worksheet);
            
            setfilerjson(json)
        };
        setfiler(e.target.files[0])
        reader.readAsArrayBuffer(e.target.files[0]);
        
    }
}else{

    // handleClicksnack()
    // setmessage("Upload Excel Data Only")
    // setstated("error")

}
}



const uloadsxcel=()=>{

    setloading(true)
    
    const fd = new FormData()
                      
                        fd.append("files",filer)
                        // fd.append("schoolID",admin.schoolID)

                        const uploading = async() => {
                            await axios.post("https://embert.sisrevolution.com/api/farmer/addfarmerexcel/", fd, {
                            // await axios.post("https://embert.sisrevolution.com/api/students/importstudents/", fd, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
    
    
                            }).then(res => {
    
                                if (res.status === 200  && res.data.length !== 0) {
                                    setloading(false)
                                    console.log(res)
                                    dispatch(getfarmer({
    
                                        data: res.data
                
                                    }))
                            //         handleClicksnack()
                            //         setmessage("Student Data Imported")
                            // setstated("success")
                            // setnewstudentloading(!true)
    
                                }else{
                                  setloading(false)
                            //         handleClicksnack()
                            // setmessage("Error Importing Student Data")
                            // setstated("success")
                            // setnewstudentloading(!true)
                                }
    
                            })
    
                        }
    
                        try{
    
                     uploading()
                    }
                    catch(err){
                      setloading(false)
                        // setmessage("Network Error")
                        // setstated("error")
                        // setnewstudentloading(!true)
                        // handleClicksnack()
                    }
    
    }
    


  return (
    <div>
     
     
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>Import Farmer</Button>
      

  
      <Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
 <DialogTitle id="customized-dialog-title" onClose={handleClose} >
            Add new Farmer
      
        <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
       
    </DialogTitle>



    <Divider/>

    <DialogContent dividers>
<p>Download the excel formart, fill and upload to be imported into the database</p>
              <a download="Import Farmers' Data" type={Button} href={Excelformart}>Download Excel formart here</a>
              <br/>
              <br/>
<p ><b>Upload the Filled excel data here</b></p>
              <input type="file" onChange={(e)=>readUploadFile(e)}/>
                    
                    {/* <DropzoneArea
        onChange={(e)=>readUploadFile(e)}
        /> */}
              


                    </DialogContent>

  <Divider/>
    <DialogActions>






<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
             : 
<Button autoFocus onClick={() => uloadsxcel()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Import Farmers Data
                                </Button>        }
        </div>

        
    </DialogActions>
</Dialog>









    </div>
  );
}
